// import React, { useRef } from "react";
// import { useDispatch } from "react-redux";
// import { useReactToPrint } from "react-to-print";
// import PrintKot from "../../component/PrintKOT/PrintKOT";
// import { OrderStatus } from "../../Utills/enums";
// import { formatFullDate } from '../../Utills/utils';
// import { updateOrderStatus } from "../../redux/action";

// const LiveOrderCard = ({ order, tableOtp = null }) => {
//   const dispatch = useDispatch();
//   const kotRef = useRef();

//   const handleKotPrint = useReactToPrint({
//     // content: () => kotRef.current,
//     contentRef: kotRef,
//   });

//    const handleDelete = (categoryId) => {
//       setIsDeleteCategories(categoryId)
//       dispatch(openGlobalPopup("confirm-box"));
//     };
  

//   const firstStatus = Array.isArray(order.orders) ? order.orders[0]?.status : undefined;
//   const orderDateTime = Array.isArray(order.orders) ? order.orders[0]?.orderDateTime : "";
//   const orderIds = Array.isArray(order.orders) ? order.orders.map(item => item.orderId) : [];

//   return (
//     <div className="order-card">
//       <div className="order-header">
//         <span className="order-id">Order #{order.orderNumber}</span>
//         <span className="status served">{formatFullDate(orderDateTime)}</span>
//         {firstStatus !== undefined && (
//           <div className={`status ${OrderStatus[firstStatus].toLowerCase()}`}>
//             {OrderStatus[firstStatus]}
//           </div>
//         )}
//       </div>

//       <div className="order-body">
//         <p>
//           <span className="print-btn" onClick={handleKotPrint}>
//             <span role="img" aria-label="print">🖨️</span>
//             <span className="tooltip">Print KOT</span>
//           </span>
//           <strong>Table:</strong> {order.tableNumber}
//         </p>

//         <table className="items-table">
//           <thead>
//             <tr>
//               <th>Item</th>
//               <th>Qty</th>
//               <th>Cancel</th>
//             </tr>
//           </thead>
//           <tbody>
//             {Array.isArray(order.orders) && order.orders.map((item) => (
//               <tr key={item.orderId}>
//                 <td>
//                   {item.foodName}
//                   {item.note !== null ? (
//                     <span className="note-container" data-note={item.note}>
//                       <span className="note-icon">📜</span>
//                     </span>
//                   ) : ""}
//                 </td>
//                 <td>{item.qty}</td>
//                 <td>
//                   <span
//                     className="link-btn danger"
//                     onClick={() =>
//                       dispatch(updateOrderStatus({
//                         tableNumber: order.tableNumber,
//                         orderIds:[item.orderId],
//                         status: "Cancelled",
//                         tableOtp:tableOtp
//                       }))
//                     }
//                   >
//                     ✖
//                   </span>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div className="order-actions">
//         <button
//           className="btn-ready"
//           onClick={() =>
//             dispatch(updateOrderStatus({
//               tableNumber: order.tableNumber,
//               orderIds: orderIds,
//               status: "Ready",
//               tableOtp:tableOtp
//             }))
//           }
//         >
//           Mark Ready
//         </button>

//         <button
//           className="btn-preparing"
//           onClick={() =>
//             dispatch(updateOrderStatus({
//               tableNumber: order.tableNumber,
//               orderIds: orderIds,
//               status: "Preparing",
//               tableOtp:tableOtp
//             }))
//           }
//         >
//           Mark Preparing
//         </button>

//         <button
//           className="btn-cancel"
//           onClick={() =>
//             dispatch(updateOrderStatus({
//               tableNumber: order.tableNumber,
//               orderIds: orderIds,
//               status: "Cancelled",
//               tableOtp:tableOtp
//             }))
//           }
//         >
//           Cancel
//         </button>
//       </div>

//       {/* Hidden print content */}
//       <div style={{ display: "none" }}>
//         <PrintKot
//           ref={kotRef}
//           items={Array.isArray(order.orders) ? order.orders : []}
//           bill={order}
//           liveOrderKot={true}
//         />
//       </div>
//     </div>
//   );
// };


// export default LiveOrderCard;


import React, { useRef } from "react";
import { getCurrentLocale } from "../../i18n/locale";
import { useDispatch } from "react-redux";
import PrintKot from "../../component/PrintKOT/PrintKOT";
import { OrderStatus } from "../../Utills/enums";
import { updateOrderStatus, openGlobalPopup } from "../../redux/action";
import { useTranslation } from "react-i18next";
import { useTrackedPrint } from "../../Utills/useTrackedPrint";

const LiveOrderCard = ({ order, tableOtp = null, onOpenCancelConfirm }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const kotRef = useRef();

  const handleKotPrint = useTrackedPrint({ contentRef: kotRef, documentType: "KOT",
    getDocumentId: () => `${order.tableNumber || "table"}-${order.orderNumber || "order"}` });

  const firstStatus = Array.isArray(order.orders) ? order.orders[0]?.status : undefined;
  const statusId = firstStatus !== undefined ? Number(firstStatus) : undefined;
  const kdsStatus = Array.isArray(order.orders) ? order.orders[0]?.kdsStatus : undefined;
  const statusName = kdsStatus === "ACCEPTED" && statusId === 0 ? "Accepted" : statusId !== undefined ? OrderStatus[statusId] : undefined;
  const orderDateTime = Array.isArray(order.orders) ? order.orders[0]?.orderDateTime : "";
  const orderIds = Array.isArray(order.orders) ? order.orders.map(item => item.orderId) : [];

  // Pass cancellation data to parent component
  const triggerCancelModal = (ids, label) => {
    onOpenCancelConfirm({
      tableNumber: order.tableNumber,
      orderIds: ids,
      label: label
    });
    dispatch(openGlobalPopup("confirm-box"));
  };

  return (
    <article className={`takeaway-order-card dinein-order-card${statusId !== undefined ? ` dinein-status-${statusId}` : ""}`}>
      <header>
        <div>
          <span className="takeaway-token">{t("Order")} #{order.orderNumber}</span>
          <small>{orderDateTime ? new Date(orderDateTime).toLocaleString(getCurrentLocale()) : ""}</small>
        </div>
        {statusName && <span className="takeaway-status">{statusName}</span>}
      </header>

      <div className="order-body">
        <p>
          <span className="print-btn" onClick={handleKotPrint}>
            <span role="img" aria-label="print">🖨️</span>
            <span className="tooltip">Print KOT</span>
          </span>
          <strong>Table:</strong> {order.tableNumber}
        </p>

        <table className="items-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Qty</th>
              <th>Cancel</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(order.orders) && order.orders.map((item) => (
              <tr key={item.orderId}>
                <td>
                  {item.foodName}
                  
                  {typeof item.note === "string" && item.note.trim() ? (
                    <span className="note-container" data-note={item.note}>
                      <span className="note-icon">📜</span>
                    </span>
                  ) : ""} 
                  <small style={{ color: "#6b7280", display: "block", fontSize: "12px" }}>
                    {item.addonSummary}
                  </small>
                </td>
                <td>{item.qty}</td>
                <td>
                  <span
                    className="link-btn danger"
                    title="Cancel Item"
                    onClick={() => triggerCancelModal([item.orderId], item.foodName)}
                  >
                    ✖
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="takeaway-card-actions">
        <button type="button" onClick={handleKotPrint}>Print KOT</button>

        {statusId === 0 && (
          <button
            type="button"
            className="primary"
            onClick={() =>
              dispatch(updateOrderStatus({
                tableNumber: order.tableNumber,
                orderIds: orderIds,
                status: "Preparing",
                tableOtp: tableOtp
              }))
            }
          >
            Mark Preparing
          </button>
        )}

        {statusId === 1 && (
          <button
            type="button"
            className="primary"
            onClick={() =>
              dispatch(updateOrderStatus({
                tableNumber: order.tableNumber,
                orderIds: orderIds,
                status: "Ready",
                tableOtp: tableOtp
              }))
            }
          >
            Mark Ready
          </button>
        )}

        <button
          type="button"
          className="danger"
          onClick={() => triggerCancelModal(orderIds, `Order #${order.orderNumber}`)}
        >
          Cancel
        </button>
      </div>

      {/* Hidden print content */}
      <div style={{ display: "none" }}>
        <PrintKot
          ref={kotRef}
          items={Array.isArray(order.orders) ? order.orders : []}
          bill={order}
          liveOrderKot={true}
        />
      </div>
    </article>
  );
};

export default LiveOrderCard;
